export default "__VITE_ASSET__BZYN8Nm8__"